// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3Hyw5","title":"Images45_title__1mV-T","images":"Images45_images__1Q7j4"};